import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/auth";
import { useApp } from "@/components/app/AppKit";

const b64 = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};
const supported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// Settings: phone notifications (daily whisper, partner invitations). Works once the app is installed on the home screen on iPhone.
export default function PushToggle() {
  const app = useApp();
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!supported()) return;
    navigator.serviceWorker.getRegistration(app.base).then((r) => r?.pushManager.getSubscription()).then((s) => setOn(Boolean(s))).catch(() => {});
  }, [app.base]);
  if (!supported()) return <section data-testid="push-toggle" className="mt-6 border border-[#D9B47A]/20 p-5 text-sm text-[#A8998C]">Notifications: add the app to your home screen first, then turn them on here.</section>;
  const toggle = async () => {
    setBusy(true);
    try {
      const reg = (await navigator.serviceWorker.getRegistration(app.base)) || (await navigator.serviceWorker.register("/temple-sw.js", { scope: app.base }));
      const existing = await reg.pushManager.getSubscription();
      if (on && existing) {
        await api.post("/push/unsubscribe", { endpoint: existing.endpoint }).catch(() => {});
        await existing.unsubscribe();
        setOn(false);
        return;
      }
      if ((await Notification.requestPermission()) !== "granted") {
        toast.error("Notifications are blocked. Allow them in your phone’s settings for this app.");
        return;
      }
      const { data } = await api.get("/push/key");
      const sub = existing || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(data.key) }));
      await api.post("/push/subscribe", { subscription: sub.toJSON(), app: app.key });
      setOn(true);
      toast.success("Notifications are on.");
    } catch {
      toast.error("Notifications couldn’t be turned on here.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section data-testid="push-toggle" className="mt-6 flex items-center justify-between gap-4 border border-[#D9B47A]/20 p-5">
      <span><span className="block font-display text-xl">Notifications</span><span className="block text-sm text-[#A8998C]">{app.key === "gates" ? "Today’s whisper and partner breath invitations" : "Partner invitations from the Temple"}</span></span>
      <button data-testid="push-toggle-switch" role="switch" aria-checked={on} disabled={busy} onClick={toggle} className={`relative w-12 h-7 shrink-0 rounded-full transition-colors disabled:opacity-60 ${on ? "bg-[#D9B47A]" : "bg-[#3a2a1c]"}`}>
        <span className={`absolute top-1 w-5 h-5 rounded-full bg-[#0A0706] transition-transform ${on ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </section>
  );
}
